import "./compound-interest-calculator.84e41aed.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6be7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6be7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8J5NX", function(module, exports) {

$parcel$export(module.exports, "PROMO_PLATFORM", () => $65a70769fc9d3215$export$7a0a4aa3b81a19a0);
$parcel$export(module.exports, "matchesPromoPlatform", () => $65a70769fc9d3215$export$d0469a70136a7590);
// Sistema operativo del visitatore, per le promo che dipendono dalla piattaforma.
// nchova gira solo su Mac: sui Mac desktop gli spazi promozionali mostrano nchova al
// posto di Switcho. Lo decide lo script in linea dei partial consent-and-tags-head*,
// che scrive <html data-promo-platform> prima del primo paint; il CSS
// (css/promo-nchova.css) nasconde la variante che non vale con [data-promo-for].
// Senza attributo vale "other" (Switcho), come per il CSS.
const $65a70769fc9d3215$export$7a0a4aa3b81a19a0 = typeof document !== 'undefined' && document.documentElement.dataset.promoPlatform === 'macos' ? 'macos' : 'other';
function $65a70769fc9d3215$export$d0469a70136a7590(el) {
    const target = el?.dataset?.promoFor;
    return !target || target === $65a70769fc9d3215$export$7a0a4aa3b81a19a0;
}

});

parcelRegister("eZ0we", function(module, exports) {

$parcel$export(module.exports, "PAGE_LANG", () => $ae872a3a7edb7f6b$export$115162aea5a8ed44);
$parcel$export(module.exports, "UI_LOCALE", () => $ae872a3a7edb7f6b$export$7d2f96c91533b722);
$parcel$export(module.exports, "registerTranslations", () => $ae872a3a7edb7f6b$export$595d4929f5276beb);
$parcel$export(module.exports, "t", () => $ae872a3a7edb7f6b$export$625550452a3fa3ec);
$parcel$export(module.exports, "langPath", () => $ae872a3a7edb7f6b$export$1b227894fc2d04d0);
// Helper i18n minimale condiviso dai tool (CV Builder, interesse composto, ...).
// Le chiavi sono le stringhe italiane originali: una voce mancante nel dizionario
// degrada in italiano invece di rompere la UI.
//
// Uso:
//   import { t, PAGE_LANG, UI_LOCALE, langPath, registerTranslations } from './i18n.js';
//   registerTranslations(MY_EN_DICT); // una volta, all'init del modulo
//   t('Annulla')                        -> 'Cancel' su pagine EN, 'Annulla' su pagine IT
//   t('Mancano {n} immagini', { n: 3 }) -> interpolazione {placeholder} in entrambe le lingue
const $ae872a3a7edb7f6b$var$docLang = typeof document !== 'undefined' && document.documentElement?.lang || '';
const $ae872a3a7edb7f6b$var$pathIsEn = typeof location !== 'undefined' && (location.pathname === '/en' || location.pathname.startsWith('/en/'));
const $ae872a3a7edb7f6b$export$115162aea5a8ed44 = $ae872a3a7edb7f6b$var$docLang.toLowerCase().startsWith('en') || !$ae872a3a7edb7f6b$var$docLang && $ae872a3a7edb7f6b$var$pathIsEn ? 'en' : 'it';
const $ae872a3a7edb7f6b$export$7d2f96c91533b722 = $ae872a3a7edb7f6b$export$115162aea5a8ed44 === 'en' ? 'en-GB' : 'it-IT';
const $ae872a3a7edb7f6b$var$EN_DICT = {};
function $ae872a3a7edb7f6b$export$595d4929f5276beb(map) {
    if (map && typeof map === 'object') Object.assign($ae872a3a7edb7f6b$var$EN_DICT, map);
}
function $ae872a3a7edb7f6b$export$625550452a3fa3ec(str, vars) {
    let out = $ae872a3a7edb7f6b$export$115162aea5a8ed44 === 'en' ? $ae872a3a7edb7f6b$var$EN_DICT[str] ?? str : str;
    if (vars) out = out.replace(/\{(\w+)\}/g, (match, key)=>key in vars ? String(vars[key]) : match);
    return out;
}
function $ae872a3a7edb7f6b$export$1b227894fc2d04d0(path) {
    return $ae872a3a7edb7f6b$export$115162aea5a8ed44 === 'en' ? `/en${path}` : path;
}

});


var $4OFpt = parcelRequire("4OFpt");

var $8J5NX = parcelRequire("8J5NX");
const $3c648122aa00176f$var$PROMO_SELECTOR = '[data-promo-card]';
class $3c648122aa00176f$var$PromoCardWidget {
    constructor(root){
        this.root = root;
        this.currentPromoIndex = 0;
        this.interval = null;
        this.availablePromos = [];
        this.touchStartX = 0;
        this.touchEndX = 0;
        this.isTransitioning = false;
        this.carouselContainer = null;
        this.dotsContainer = null;
        this.prevBtn = null;
        this.nextBtn = null;
        this.stableHeight = 0;
    }
    init() {
        this.cacheElements();
        this.availablePromos = this.extractTemplates();
        if (!this.availablePromos.length) return;
        this.applyStableHeightFromDom();
        this.renderCurrent();
        this.carouselContainer.classList.remove('promo-card-nojs');
        this.setupControls();
        this.setupEventListeners();
        this.startAutoplay();
    }
    cacheElements() {
        this.carouselContainer = this.root.querySelector('.promo-card-container');
        this.dotsContainer = this.root.querySelector('.promo-card-dots');
        this.prevBtn = this.root.querySelector('.promo-card-nav-prev');
        this.nextBtn = this.root.querySelector('.promo-card-nav-next');
    }
    extractTemplates() {
        if (!this.carouselContainer) return [];
        // Le card per un'altra piattaforma (nchova sui Mac, Switcho altrove) escono dal
        // DOM prima di misurare l'altezza stabile e di contare i pallini.
        this.carouselContainer.querySelectorAll('.promo-card[data-promo-for]').forEach((card)=>{
            if (!(0, $8J5NX.matchesPromoPlatform)(card)) card.remove();
        });
        const cards = Array.from(this.carouselContainer.querySelectorAll('.promo-card'));
        const reviewCard = cards.find((card)=>card.classList.contains('promo-card-review') || card.dataset.promoSlide === 'review');
        const promoCards = cards.filter((card)=>card !== reviewCard);
        const templates = [];
        if (reviewCard?.dataset.toolSlug?.trim()) templates.push({
            type: 'review',
            html: reviewCard.outerHTML
        });
        templates.push(...promoCards.map((card)=>({
                html: card.outerHTML,
                partner: card.dataset.partner || null
            })));
        return templates;
    }
    getCurrentTemplate() {
        return this.availablePromos[this.currentPromoIndex] || this.availablePromos[0];
    }
    renderCurrent() {
        if (!this.carouselContainer) return;
        this.carouselContainer.innerHTML = '';
        const card = this.createPromoCardFromTemplate(this.getCurrentTemplate());
        if (card) {
            this.carouselContainer.appendChild(card);
            const cardHeight = card.offsetHeight;
            if (cardHeight > 0) this.carouselContainer.style.minHeight = `${Math.max(this.stableHeight, cardHeight)}px`;
        }
    }
    applyStableHeightFromDom() {
        if (!this.carouselContainer) return;
        const cards = Array.from(this.carouselContainer.querySelectorAll('.promo-card'));
        if (!cards.length) return;
        let maxHeight = 0;
        cards.forEach((card)=>{
            const prevDisplay = card.style.display;
            const prevPosition = card.style.position;
            const prevVisibility = card.style.visibility;
            const prevLeft = card.style.left;
            const prevTop = card.style.top;
            const prevWidth = card.style.width;
            card.style.display = 'flex';
            card.style.position = 'absolute';
            card.style.visibility = 'hidden';
            card.style.left = '0';
            card.style.top = '0';
            card.style.width = '100%';
            maxHeight = Math.max(maxHeight, card.offsetHeight);
            card.style.display = prevDisplay;
            card.style.position = prevPosition;
            card.style.visibility = prevVisibility;
            card.style.left = prevLeft;
            card.style.top = prevTop;
            card.style.width = prevWidth;
        });
        if (maxHeight > 0) {
            this.stableHeight = maxHeight;
            this.carouselContainer.style.minHeight = `${maxHeight}px`;
        }
    }
    createPromoCardFromTemplate(template) {
        if (!template) return null;
        if (template.type === 'review') {
            const wrapper = document.createElement('div');
            wrapper.innerHTML = template.html;
            const card = wrapper.firstElementChild;
            if (!card) return null;
            card.hidden = false;
            card.removeAttribute('hidden');
            (0, $4OFpt.attachToolReview)(card);
            return card;
        }
        const wrapper = document.createElement('div');
        wrapper.innerHTML = template.html;
        const card = wrapper.firstElementChild;
        if (!card) return null;
        if (card.tagName === 'A') {
            const linkOptions = card.dataset.linkOptions ? JSON.parse(card.dataset.linkOptions) : null;
            if (Array.isArray(linkOptions) && linkOptions.length > 1) {
                const randomIndex = Math.floor(Math.random() * linkOptions.length);
                card.href = linkOptions[randomIndex];
            }
        // Click tracking handled by trackedLinks.js via data-track attribute
        }
        return card;
    }
    setupControls() {
        const controls = this.root.querySelector('.promo-card-controls');
        const showControls = this.availablePromos.length > 1;
        if (!controls) return;
        controls.style.display = showControls ? 'flex' : 'none';
        if (!showControls || !this.dotsContainer) return;
        this.dotsContainer.innerHTML = this.availablePromos.map((_, index)=>{
            const activeClass = index === this.currentPromoIndex ? 'active' : '';
            return `
          <button class="promo-card-dot ${activeClass}" aria-label="Go to slide ${index + 1}"></button>
        `;
        }).join('');
        this.setupDotsHandlers();
    }
    setupDotsHandlers() {
        if (!this.dotsContainer) return;
        this.dotsContainer.querySelectorAll('.promo-card-dot').forEach((dot, index)=>{
            dot.addEventListener('click', ()=>this.goToPromo(index));
        });
    }
    setupEventListeners() {
        if (this.prevBtn) this.prevBtn.addEventListener('click', ()=>this.prevPromo());
        if (this.nextBtn) this.nextBtn.addEventListener('click', ()=>this.nextPromo());
        const carousel = this.root.querySelector('.promo-card-carousel');
        if (carousel) {
            carousel.addEventListener('touchstart', (event)=>{
                this.touchStartX = event.changedTouches[0].screenX;
            });
            carousel.addEventListener('touchend', (event)=>{
                this.touchEndX = event.changedTouches[0].screenX;
                this.handleSwipe();
            });
            carousel.addEventListener('mouseenter', ()=>this.stopAutoplay());
            carousel.addEventListener('mouseleave', ()=>this.startAutoplay());
        }
    }
    updateDots() {
        if (!this.dotsContainer) return;
        this.dotsContainer.querySelectorAll('.promo-card-dot').forEach((dot, index)=>{
            dot.classList.toggle('active', index === this.currentPromoIndex);
        });
    }
    startAutoplay() {
        const rotationEnabled = this.root.getAttribute('data-rotation-enabled') !== 'false';
        if (!rotationEnabled || this.availablePromos.length <= 1) return;
        this.stopAutoplay();
        this.interval = setInterval(()=>{
            this.nextPromo();
        }, 15000);
    }
    stopAutoplay() {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
    }
    nextPromo() {
        if (this.availablePromos.length <= 1 || this.isTransitioning) return;
        this.isTransitioning = true;
        this.currentPromoIndex = (this.currentPromoIndex + 1) % this.availablePromos.length;
        this.animateTransition('next');
    }
    prevPromo() {
        if (this.availablePromos.length <= 1 || this.isTransitioning) return;
        this.isTransitioning = true;
        this.currentPromoIndex = (this.currentPromoIndex - 1 + this.availablePromos.length) % this.availablePromos.length;
        this.animateTransition('prev');
    }
    goToPromo(index) {
        if (index === this.currentPromoIndex || this.isTransitioning) return;
        this.isTransitioning = true;
        const direction = index > this.currentPromoIndex ? 'next' : 'prev';
        this.currentPromoIndex = index;
        this.animateTransition(direction);
    }
    animateTransition(direction) {
        if (!this.carouselContainer) {
            this.isTransitioning = false;
            return;
        }
        const oldCard = this.carouselContainer.querySelector('.promo-card');
        const newCard = this.createPromoCardFromTemplate(this.getCurrentTemplate());
        if (!newCard) {
            this.isTransitioning = false;
            return;
        }
        const currentHeight = oldCard ? oldCard.offsetHeight : 0;
        const slideOffset = 106;
        newCard.style.position = 'absolute';
        newCard.style.width = '100%';
        newCard.style.transform = direction === 'next' ? `translateX(${slideOffset}%)` : `translateX(-${slideOffset}%)`;
        if (oldCard) {
            oldCard.style.position = 'absolute';
            oldCard.style.width = '100%';
        }
        this.carouselContainer.appendChild(newCard);
        const nextHeight = newCard.offsetHeight;
        const minHeight = Math.max(this.stableHeight, currentHeight, nextHeight);
        if (minHeight > 0) this.carouselContainer.style.minHeight = `${minHeight}px`;
        newCard.offsetHeight;
        requestAnimationFrame(()=>{
            if (oldCard) oldCard.style.transform = direction === 'next' ? `translateX(-${slideOffset}%)` : `translateX(${slideOffset}%)`;
            newCard.style.transform = 'translateX(0)';
            setTimeout(()=>{
                if (oldCard) oldCard.remove();
                newCard.style.position = 'relative';
                this.isTransitioning = false;
                this.updateDots();
            }, 300);
        });
        this.startAutoplay();
    }
    handleSwipe() {
        const swipeThreshold = 50;
        const diff = this.touchStartX - this.touchEndX;
        if (Math.abs(diff) > swipeThreshold) {
            if (diff > 0) this.nextPromo();
            else this.prevPromo();
        }
    }
}
function $3c648122aa00176f$var$isPromoInHiddenResultSection(root) {
    const section = root.closest('.result-section');
    return Boolean(section && getComputedStyle(section).display === 'none');
}
function $3c648122aa00176f$export$a5ec26bf244a70a9(scope = document) {
    const roots = scope === document ? [
        ...document.querySelectorAll($3c648122aa00176f$var$PROMO_SELECTOR)
    ] : scope.matches?.($3c648122aa00176f$var$PROMO_SELECTOR) ? [
        scope
    ] : [
        ...scope.querySelectorAll($3c648122aa00176f$var$PROMO_SELECTOR)
    ];
    roots.forEach((root)=>{
        if ($3c648122aa00176f$var$isPromoInHiddenResultSection(root)) return;
        if (root.dataset.promoCardReady === 'true') return;
        root.dataset.promoCardReady = 'true';
        const widget = new $3c648122aa00176f$var$PromoCardWidget(root);
        root._promoCardWidget = widget;
        widget.init();
    });
}
function $3c648122aa00176f$var$observeHiddenResultSections() {
    document.querySelectorAll('.result-section').forEach((section)=>{
        if (getComputedStyle(section).display === 'none') {
            const observer = new MutationObserver(()=>{
                if (getComputedStyle(section).display !== 'none') {
                    $3c648122aa00176f$export$a5ec26bf244a70a9(section);
                    observer.disconnect();
                }
            });
            observer.observe(section, {
                attributes: true,
                attributeFilter: [
                    'style',
                    'class'
                ]
            });
        }
    });
}
const $3c648122aa00176f$var$scheduleInitPromoCards = ()=>{
    const run = ()=>{
        $3c648122aa00176f$export$a5ec26bf244a70a9();
        $3c648122aa00176f$var$observeHiddenResultSections();
    };
    if (document.readyState === 'complete') {
        run();
        return;
    }
    document.addEventListener('DOMContentLoaded', run, {
        once: true
    });
};
$3c648122aa00176f$var$scheduleInitPromoCards();
if (typeof window !== 'undefined') window.initPromoCards = $3c648122aa00176f$export$a5ec26bf244a70a9;


//# sourceMappingURL=risultati.af708e9e.js.map
